// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"37c706f7","138":"c6dcbe50","193":"7900a69c","231":"3aac4c25","239":"36b55538","252":"e5758938","289":"5ffcb864","453":"46eaa295","504":"6bc0d330","516":"3b2cb878","553":"50cc0ed1","855":"431aa920","881":"e61cad09","963":"66f0264b"}[chunkId] + ".chunk.js";
};